import { PaidFeature } from '@baserow_premium/paidFeatures'
import {
  AdvancedWebhooksPaidFeature,
  AuditLogPaidFeature,
  DataSyncPaidFeature,
  RBACPaidFeature,
  SupportWebhooksPaidFeature,
} from '@baserow_enterprise/paidFeatures'

export class AdvancedAdvancedWebhooksPaidFeature extends AdvancedWebhooksPaidFeature {
  getPlan() {
    return 'Advanced'
  }
}

export class AdvancedAuditLogPaidFeature extends AuditLogPaidFeature {
  getPlan() {
    return 'Advanced'
  }

  getImage() {
    return '/img/features/workspace_audit_log.png'
  }
}

export class AdvancedRBACPaidFeature extends RBACPaidFeature {
  getPlan() {
    return 'Advanced'
  }
}

export class AdvancedDataSyncPaidFeature extends DataSyncPaidFeature {
  getPlan() {
    return 'Advanced'
  }
}

export class AdvancedupportWebhooksPaidFeature extends SupportWebhooksPaidFeature {
  getPlan() {
    return 'Advanced'
  }
}

export class ApplicationBuilderSSOPaidFeature extends PaidFeature {
  static getType() {
    return 'ab_sso'
  }

  getPlan() {
    return 'Advanced'
  }

  getIconClass() {
    return 'iconoir-log-in'
  }

  getName() {
    return this.app.i18n.t('advancedFeatures.abSSO')
  }

  getImage() {
    return '/img/features/ab_sso.png'
  }

  getContent() {
    return this.app.i18n.t('advancedFeatures.abSSOContent')
  }
}
